/**
 * Attempts to return the given number as a whole number, assuming
 * the "fraction" piece is equal to zero. If not, it returns as-is.
 *
 * Note: This function intentionally assumes the presence of
 *    NF.formatToParts()
 *
 * @param {NumberFormat} numberFormat The NumberFormat object
 * @param {number} number The number to generate
 */
export const getAsWholeNumberWhenPossible = (numberFormat, number) => {
  const parts = numberFormat.formatToParts(number);
  const fractPiece = parts.find(p => p.type === 'fraction');

  // No fraction was found, therefore we return the number as-is
  if (!fractPiece) {
    return parts.map(p => p.value).join('');
  }

  // We have a fraction, now determine whether the value is zero
  const fractValIsZero = Number(fractPiece.value) === 0;

  // The fraction value is equal to zero
  if (fractValIsZero) {
    return parts
      // Remove the decimal and fraction objects
      .filter(({ type }) => !['decimal', 'fraction'].includes(type))
      // Push into a single array
      .map(({ value }) => value)
      // Mush the filtered array into a string
      .join('');
  }

  // Our fraction isn't zero, therefore return as-is
  return parts.map(p => p.value).join('');
};

export default getAsWholeNumberWhenPossible;
